import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from 'react-redux';
import MarkdownRenderer from '../../../../mobile/mobileComponents/mobileProductDetails/MarkdownRenderer';

const TermsAndCondition = () => {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);

  return (
    <Box sx={{ mt: 2 }}>
      {/* How to Redeem */}
      <Accordion
        disableGutters
        elevation={0}
        sx={{
          mb: 1.5,
          borderRadius: '12px',
          bgcolor: '#f5f5f5',
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={
            <KeyboardArrowDownIcon sx={{ backgroundColor: '#0b2e5f', color: 'white.main', borderRadius: 5 }} />
          }
        >
          <Typography fontWeight={600}>How to Redeem</Typography>
        </AccordionSummary>

        <AccordionDetails>
          {PRODUCTDETAILS?.redeem?.trim()?.length ? (
            <MarkdownRenderer content={PRODUCTDETAILS?.redeem} />
          ) : (
            <Typography variant="body2" color="primary.main" textAlign="center">
              Information not available
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Terms & Conditions */}
      <Accordion
        disableGutters
        elevation={0}
        sx={{
          mb: 1.5,
          borderRadius: '12px',
          bgcolor: '#f5f5f5',
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={
            <KeyboardArrowDownIcon sx={{
              backgroundColor: '#0b2e5f', color: 'white.main', borderRadius: 5
            }} />
          }
        >
          <Typography fontWeight={600}>Terms & Conditions</Typography>
        </AccordionSummary>

        <AccordionDetails>
          {PRODUCTDETAILS?.terms?.trim()?.length ? (
            <MarkdownRenderer content={PRODUCTDETAILS?.terms} />
          ) : (
            <Typography variant="body2" color="primary.main" textAlign="center">
              Information not available
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default TermsAndCondition;
